import {writeStore} from '../../helpers'
import {useVisibleColumns, useGroupedColumn} from '../../hooks'
import {getTableHeaderFieldName} from '../../components'
import {Select} from '~/components/select'

export const ColumnPicker = ({fields: allTableColumns, defaultVisibleColumns, trigger, tableName, recordType, ...rest}) => {
	const _name = `${tableName}_table.fields`
	const visibleColumns = useVisibleColumns({tableName, allTableColumns, defaultVisibleColumns})
	const savedGrouping = useGroupedColumn({tableName})
	const columnItems = allTableColumns.map(f => mapField(f, tableName, recordType, savedGrouping))

	return (
		<Select
			trigger={{t: 'common.column_plural', 'data-intercom-target': 'column_picker', dropdown: !trigger, ...trigger, ...rest}}
			type="multiple"
			items={columnItems}
			value={visibleColumns}
			onChange={value => writeStore(tableName, {visible: [savedGrouping, ...value]})}
			minItems={1}
		/>
	)
}

const mapField = (field, name, recordType, savedGrouping) => {
	const _name = getTableHeaderFieldName({field, name, recordType})
	return {id: field, name: _name, disabled: savedGrouping === field && 'table.cant_hide_grouped'}
}
